import React from 'react';

export default function LoadingSpinner({ message }) {
  return (
    <div className="page-loading">
      <div className="page-loading-spinner" />
      {message && <p className="page-loading-text">{message}</p>}
    </div>
  );
}
